// Carrusel desde el lienzo — ADR-2026-09-16-las-herramientas-del-lienzo-abren-en-panel.
//
// El sheet es el de siempre (`CarruselMenu`, con su stepper); lo que era del visor —el
// guard de saldo antes de mostrarlo y armar la promesa de ids— vive acá, en ~30 líneas.
// La promesa se entrega SIN esperarla: el lienzo pone los recuadros debajo de la foto y
// la cierra cuando resuelve.

import { useEffect, useState } from 'react';
import CarruselMenu from '../../../components/CarruselMenu';
import { postGenerateAnglesFrom } from '../../../lib/generateAngles';
import { supabase } from '../../../lib/supabase';
import type { PropsDeHerramienta } from './herramienta';
import { consultarSaldo, tipoDeLimite } from './saldo';

export const PanelCarrusel: React.FC<PropsDeHerramienta> = ({
  celda,
  ratio,
  onCerrar,
  onGeneracion,
  onLimite,
}) => {
  const [listo, setListo] = useState(false);
  useEffect(() => {
    let vivo = true;
    void consultarSaldo(celda.companyId).then((s) => {
      if (!vivo) return;
      if (s.restantes !== null && s.restantes <= 0) {
        onLimite(tipoDeLimite(s.plan));
        onCerrar();
        return;
      }
      setListo(true);
    });
    return () => {
      vivo = false;
    };
  }, [celda.companyId, onCerrar, onLimite]);

  const confirmar = (cantidad: number) => {
    const resultado = (async (): Promise<string[]> => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error('No se pudo identificar al usuario');
      const ids = await postGenerateAnglesFrom(
        { tipo: 'generada', imageId: celda.imageId },
        { userId: user.id, cantidad },
      );
      if (ids.length === 0) throw new Error('No se pudo generar nuevos ángulos. Intentá nuevamente.');
      return ids;
    })();
    onGeneracion({
      tipo: 'carrusel',
      total: cantidad,
      creditos: cantidad,
      ratio,
      producto: celda.titulo,
      esVideo: false,
      origenId: celda.imageId,
      resultado,
    });
    onCerrar();
  };

  return <CarruselMenu open={listo} onClose={onCerrar} onConfirm={confirmar} />;
};
